import { z } from 'zod';

// PostgreSQL accepte les UUID historiques sans bits de version RFC. `z.guid()`
// conserve le format canonique 8-4-4-4-12 sans rejeter ces identifiants existants.
export const companyIdSchema = z.guid({
  error: 'L’identifiant de l’entreprise est invalide.',
});

export type CompanyId = z.infer<typeof companyIdSchema>;
